/**
 * Mock campaign data. Replace with REST calls once the backend exists.
 * Shape mirrors what the API should return per campaign so the UI maps 1:1.
 */
export const CAMPAIGNS = [
  {
    id: "cmp_1029",
    name: "Q2 Estimation Services Newsletter",
    subject: "New takeoff turnaround times + 3 client wins",
    status: "sent",
    type: "Newsletter",
    audience: "All Subscribers",
    recipients: 45230,
    sent: 45230,
    delivered: 44781,
    openRate: 42.1,
    clickRate: 7.8,
    bounceRate: 1.0,
    unsubRate: 0.3,
    revenue: 0,
    sentAt: "Jun 25, 2026 · 09:30",
    owner: "Admin",
    trend: [22, 30, 28, 41, 38, 52, 48],
  },
  {
    id: "cmp_1028",
    name: "Product Launch: SwiftEstimate Pro",
    subject: "Faster bids. Fewer errors. Meet SwiftEstimate Pro.",
    status: "sent",
    type: "Announcement",
    audience: "Active Clients",
    recipients: 28100,
    sent: 28100,
    delivered: 27944,
    openRate: 51.3,
    clickRate: 12.4,
    bounceRate: 0.6,
    unsubRate: 0.2,
    revenue: 18400,
    sentAt: "Jun 23, 2026 · 11:00",
    owner: "Admin",
    trend: [18, 24, 35, 40, 55, 60, 51],
  },
  {
    id: "cmp_1027",
    name: "Weekly Digest #24",
    subject: "This week in construction estimating",
    status: "sending",
    type: "Newsletter",
    audience: "Engaged (30d)",
    recipients: 18750,
    sent: 11200,
    delivered: 11098,
    openRate: 34.7,
    clickRate: 5.1,
    bounceRate: 0.9,
    unsubRate: 0.4,
    revenue: 0,
    sentAt: "In progress",
    owner: "Admin",
    trend: [30, 28, 32, 30, 35, 34, 35],
  },
  {
    id: "cmp_1026",
    name: "Win-back: Inactive 90 Days",
    subject: "We miss you — here's 20% off your next estimate",
    status: "active",
    type: "Re-engagement",
    audience: "Dormant Leads",
    recipients: 12400,
    sent: 12400,
    delivered: 12188,
    openRate: 28.9,
    clickRate: 4.3,
    bounceRate: 1.7,
    unsubRate: 0.8,
    revenue: 6200,
    sentAt: "Jun 18, 2026 · 08:00",
    owner: "Admin",
    trend: [12, 18, 22, 19, 26, 24, 29],
  },
  {
    id: "cmp_1025",
    name: "Welcome Series — Email 1",
    subject: "Welcome to SwiftReach 👋",
    status: "active",
    type: "Automated",
    audience: "New Signups",
    recipients: 3200,
    sent: 3200,
    delivered: 3187,
    openRate: 67.2,
    clickRate: 18.6,
    bounceRate: 0.4,
    unsubRate: 0.1,
    revenue: 4100,
    sentAt: "Ongoing",
    owner: "System",
    trend: [55, 60, 62, 65, 64, 68, 67],
  },
  {
    id: "cmp_1024",
    name: "Flash Offer — Summer Prep",
    subject: "48 hours only: priority estimating slots",
    status: "scheduled",
    type: "Promotion",
    audience: "High-Intent Leads",
    recipients: 8900,
    sent: 0,
    delivered: 0,
    openRate: 0,
    clickRate: 0,
    bounceRate: 0,
    unsubRate: 0,
    revenue: 0,
    sentAt: "Jul 02, 2026 · 10:00",
    owner: "Admin",
    trend: [0, 0, 0, 0, 0, 0, 0],
  },
  {
    id: "cmp_1023",
    name: "Case Study: 40% Faster Bids",
    subject: "How Apex Builders cut bid time by 40%",
    status: "draft",
    type: "Nurture",
    audience: "—",
    recipients: 0,
    sent: 0,
    delivered: 0,
    openRate: 0,
    clickRate: 0,
    bounceRate: 0,
    unsubRate: 0,
    revenue: 0,
    sentAt: "—",
    owner: "Admin",
    trend: [0, 0, 0, 0, 0, 0, 0],
  },
  {
    id: "cmp_1022",
    name: "Monthly Pricing Update",
    subject: "Updated material cost index — June",
    status: "paused",
    type: "Newsletter",
    audience: "All Subscribers",
    recipients: 41000,
    sent: 20500,
    delivered: 20100,
    openRate: 31.2,
    clickRate: 4.9,
    bounceRate: 1.2,
    unsubRate: 0.5,
    revenue: 0,
    sentAt: "Paused",
    owner: "Admin",
    trend: [28, 30, 31, 29, 32, 31, 31],
  },
];

/** Status → Badge tone + label. */
export const CAMPAIGN_STATUS = {
  sent:      { tone: "success", label: "Sent" },
  sending:   { tone: "info",    label: "Sending" },
  active:    { tone: "info",    label: "Active" },
  scheduled: { tone: "warning", label: "Scheduled" },
  draft:     { tone: "neutral", label: "Draft" },
  paused:    { tone: "high",    label: "Paused" },
};

/** Filter tabs shown in the toolbar. */
export const STATUS_TABS = [
  { key: "all",       label: "All" },
  { key: "sent",      label: "Sent" },
  { key: "active",    label: "Active" },
  { key: "scheduled", label: "Scheduled" },
  { key: "draft",     label: "Draft" },
  { key: "paused",    label: "Paused" },
];

/** Header KPI cards (aggregate, mock). */
export const CAMPAIGN_KPIS = [
  { key: "sent",   label: "Emails Sent (30d)", value: "1.24M",  change: "+12.4%", up: true },
  { key: "open",   label: "Avg Open Rate",     value: "41.8%",  change: "+3.1%",  up: true },
  { key: "click",  label: "Avg Click Rate",    value: "7.2%",   change: "+0.8%",  up: true },
  { key: "active", label: "Active Campaigns",  value: "5",      change: "+2",     up: true },
];
